import React from 'react'

const Block = () => {
    return (
        <div className='blockContainer'>
            <p className='titleBlock'>¿Tenés que hacer un regalo o simplemente mimar tu hogar?</p>
            <p className='textBlock'>Impresiones, fotocopias, anillados, plastificados, agendas, cuadernos de seguimiento docente, tazas, remeras, pad mouse, textiles, souvenirs, llaveros, objetos en madera, aromatizantes, difusores, sahumerios, cascadas de humo....
                <br />
                Y la última incorporación... ¡Sellos de goma personalizados!
                <br />
                <br />
                Pasá por nuestro local y mirá todas las opciones que tenemos para entrega inmediata.
                <br />
                <br />
                Nos caracterizamos por buscar e innovar en productos, manteniendo una excelente calidad del producto final.
            </p>
            <p className='titleBlock'>¡Regalá o regálate!</p>
        </div>
    )
}

export default Block